import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import App from '@/App';

/**
 * Imperatively inject PWA <link> tags that the CRA dev server strips from public/index.html
 * for local asset hrefs. Idempotent: only adds if missing. Works in dev AND production.
 */
function ensurePwaHeadLinks() {
  if (typeof document === 'undefined') return;
  const has = (selector) => !!document.head.querySelector(selector);
  const add = (rel, href, extra = {}) => {
    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    Object.entries(extra).forEach(([k, v]) => link.setAttribute(k, v));
    document.head.appendChild(link);
  };
  if (!has('link[rel="manifest"]')) add('manifest', '/manifest.json');
  if (!has('link[rel="apple-touch-icon"]')) add('apple-touch-icon', '/icons/icon-192.png');
  if (!has('link[rel="icon"][type="image/png"]')) {
    add('icon', '/icons/icon-192.png', { type: 'image/png', sizes: '192x192' });
  }
  // Dev-server may serve a stale title; force parity with production build.
  if (document.title === 'SignVoice — POC' || !document.title) {
    document.title = 'SignVoice — Sign Language to Voice';
  }
}
ensurePwaHeadLinks();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker only in production builds.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // eslint-disable-next-line no-console
      console.warn('[SignVoice] SW register failed:', String(err));
    });
  });
}
